import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiService } from '@core/providers/http';
import { map, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DominioService {

  public params = new HttpParams();

  constructor(private readonly apiService: ApiService) { }

  // List all logs
  list(params?: any): Observable<any> {
    return this.apiService.get(`/Dominio/InfoSobreNos`, params ? new HttpParams({
      fromObject: params
    }) : this.params,
    ).pipe(
      map(response => response)
    );
  }

  show(id: string): Observable<any> {
    return this.apiService.get(
      `/Dominio/InfoSobreNos/${id}`,
    ).pipe(
      map(response => response)
    );
  }
}
